import PageWrapper from 'components/Common/PageWrapper/PageWrapper';
import useTranslation from 'next-translate/useTranslation';
import { NextQueryParamProvider } from 'next-query-params';
import { FC } from 'react';
import { META_IMAGE_LINK_FILGRAM } from 'constants/general';
import { ROUTES } from 'constants/routes';
import SearchStorageProviders from 'components/Common/SearchStorageProviders/SearchStorageProviders';
import SearchStorageProvidersItemCustom from './SearchStorageProvidersItemCustom/SearchStorageProvidersItemCustom';

import styles from './Search.module.scss';

const Search: FC = () => {
  const { t } = useTranslation('explore');

  return (
    <NextQueryParamProvider>
      <PageWrapper
        seoData={{
          title: `${t('appTitle', null, { ns: 'common' })} - ${t(
            'exploreStorageProviders',
          )}`,
          link: `${process.env.BASE_URL}${ROUTES.EXPLORE}`,
          metaImageLink: META_IMAGE_LINK_FILGRAM,
        }}
        newStyles={styles}
        additionalClass={styles['search-wrapper']}
        requireAuth={false}
      >
        <SearchStorageProviders
          newStyles={styles}
          HitComponent={SearchStorageProvidersItemCustom}
          withUrlSync
        />
      </PageWrapper>
    </NextQueryParamProvider>
  );
};

export default Search;
